import MaplibreBlockView from './customizations/@codesyntax/volto-maplibre-block/components/Blocks/MaplibreBlock/View.jsx';
import MaplibreBlockEdit from './customizations/@codesyntax/volto-maplibre-block/components/Blocks/MaplibreBlock/Edit.jsx';
import enhanceMaplibreBlockSchema from './customizations/@codesyntax/volto-maplibre-block/components/Blocks/MaplibreBlock/schemaEnhancer';

const applyConfig = (config) => {
  config.settings.isMultilingual = false;
  config.settings.supportedLanguages = ['en'];
  config.settings.defaultLanguage = 'en';

  // config.blocks.blocksConfig.mapLibreBlock.edit = MaplibreBlockEdit;
  
  // Target the block you want to customize
  const mapLibreBlock = config.blocks.blocksConfig.mapLibreBlock;

  // Preserve existing schema enhancer (if any)
  const originalSchemaEnhancer = mapLibreBlock.schemaEnhancer;

  // Overide view and edit
  mapLibreBlock.view = MaplibreBlockView;
  mapLibreBlock.edit = MaplibreBlockEdit;

  // Wrap the original enhancer with your custom logic
  config.blocks.blocksConfig.mapLibreBlock = {
    ...mapLibreBlock,
    schemaEnhancer: enhanceMaplibreBlockSchema
  };

  return config;
};

export default applyConfig;
